<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex"> 
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="申报单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申报单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="申报人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申报人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="申报科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申报科室:{{ form.ownerDeptName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="year" label="所属年度" v-if="getIsView()">
                <el-select v-model="form.year" :disabled="!editMode" placeholder="请选择" @change="yearChange"
                  style="width:100%">
                  <el-option v-for="item in AnnualOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>所属年度:{{ form.year }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="type" label="申报类型" v-if="getIsView()">
                <el-checkbox-group v-model="form.typeArr" :disabled="!editMode" @change="typeChange" style="width:100%">
                  <el-checkbox v-for="item in DeptApplyQuotaTypeOptions" :key="item.id" :label="item.id">{{ item.name
                    }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <span class="viewText" v-else>申报类型:{{ form.typeArr }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">申报明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick
              @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div style="margin-top: 20px"></div>

          <el-table ref="childTable" v-loading="loading" border :data="form.details" :max-height="500"
            style="width: auto; margin: 0 10px" @selection-change="handleChildSelectionChange"
            :row-class-name="tableRowClassName"  :cell-class-name="cell" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column type="index" fixed label="序号" width="50"> </el-table-column>
            <el-table-column prop="deptName" fixed label="科室" width="150">
              <template slot-scope="scope">
                <el-select v-if="editMode && !scope.row.addShow" v-model="scope.row.deptName" placeholder="请选择"
                  @change="(val) => deptChange(val, scope.row)" filterable :filter-method="getDeptList"
                  style="width:100%">
                  <el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                <el-select v-if="editMode && scope.row.addShow" v-model="scope.row.deptName" placeholder="请选择"
                  @change="(val) => deptChange(val, scope.row)" filterable :filter-method="getDeptList1"
                  style="width:100%">
                  <el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <template v-if="!editMode">
                  {{ scope.row.deptName }}
                </template>
              </template>
            </el-table-column>
            <el-table-column fixed label="是否有库" min-width="80">
              <template slot-scope="scope">
                {{ scope.row.isTwoWarehouse == 1 ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column v-if="showCharge" fixed label="近年历史参考(计费)" :key="'lastYearChargeAmount'"
              prop="lastYearChargeAmount" min-width="110">

            </el-table-column>

            <el-table-column v-if="showCharge" prop="chargeAmount" :key="'chargeAmount'" fixed label="请领限额(计费)"
              min-width="110">
              <template slot-scope="scope">
                <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false" :min="0"
                  @change="(val) => chargeAmountChange(scope.row, val)" v-model="scope.row.chargeAmount"
                  style="width:100%"></el-input-number>
                <template v-else>
                  {{ scope.row.chargeAmount }}
                </template>
              </template>
            </el-table-column>
            <el-table-column v-if="showNotCharge" prop="lastYearNotChargeAmount" fixed label="近年历史参考(不计费)"
              min-width="110">
            </el-table-column>
            <el-table-column v-if="showNotCharge" prop="notChargeAmount" fixed label="请领限额(不计费)" min-width="110">
              <template slot-scope="scope">
                <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false" :min="0"
                  @change="(val) => notChargeAmountChange(scope.row, val)" v-model="scope.row.notChargeAmount"
                  style="width:100%"></el-input-number>
                <template v-else>
                  {{ scope.row.notChargeAmount }}
                </template>
              </template>
            </el-table-column>


            <el-table-column :label="columnLabel + '01'">
              <el-table-column v-if="showCharge" label="计费" width="80">
                <template slot-scope="scope">
                  
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.januaryChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.januaryChargeAmount }}
                    </template>
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="januaryNotChargeAmount" label="不计费" width="80">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'januaryNotChargeAmount')"
                    v-model="scope.row.januaryNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.januaryNotChargeAmount }}
                    </template>
                </template>
                
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '02'">
              <el-table-column v-if="showCharge" prop="februaryChargeAmount" label="计费" width="80">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.februaryChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.februaryChargeAmount }}
                    </template>
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="februaryNotChargeAmount" label="不计费" width="80">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'februaryNotChargeAmount')"
                    v-model="scope.row.februaryNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.februaryNotChargeAmount }}
                    </template>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '03'">
              <el-table-column v-if="showCharge" prop="marchChargeAmount" label="计费" width="80">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.marchChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.marchChargeAmount }}
                    </template>
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="marchNotChargeAmount" label="不计费" width="80">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'marchNotChargeAmount')"
                    v-model="scope.row.marchNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.marchNotChargeAmount }}
                    </template>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '04'">
              <el-table-column v-if="showCharge" prop="aprilChargeAmount" label="计费" width="80">
                <template slot-scope="scope">
                  <el-input-number placeholder="请输入金额" v-if="editMode" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.aprilChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.aprilChargeAmount }}
                    </template>
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="aprilNotChargeAmount" label="不计费" width="80">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'aprilNotChargeAmount')"
                    v-model="scope.row.aprilNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.aprilNotChargeAmount }}
                    </template>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '05'">
              <el-table-column v-if="showCharge" prop="mayChargeAmount" label="计费" width="80">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.mayChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.mayChargeAmount }}
                    </template>
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="mayNotChargeAmount" label="不计费" width="80">
                <template slot-scope="scope">
                  <el-input-number placeholder="请输入金额" v-if="editMode" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'mayNotChargeAmount')"
                    v-model="scope.row.mayNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.mayNotChargeAmount }}
                    </template>
                </template>
                
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '06'">
              <el-table-column v-if="showCharge" prop="juneChargeAmount" label="计费" width="100">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.juneChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.juneChargeAmount }}
                    </template>
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="juneNotChargeAmount" label="不计费" width="100">
                <template slot-scope="scope">
                  <el-input-number placeholder="请输入金额" v-if="editMode" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'juneNotChargeAmount')"
                    v-model="scope.row.juneNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.juneNotChargeAmount }}
                    </template>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '07'">
              <el-table-column v-if="showCharge" prop="julyChargeAmount" label="计费" width="80">
                <template slot-scope="scope">
                  <el-input-number placeholder="请输入金额" v-if="editMode" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.julyChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.julyChargeAmount }}
                    </template>
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="julyNotChargeAmount" label="不计费" width="80">
                <template slot-scope="scope">
                  <el-input-number placeholder="请输入金额"  v-if="editMode" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'julyNotChargeAmount')"
                    v-model="scope.row.julyNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.julyNotChargeAmount }}
                    </template>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '08'">
              <el-table-column v-if="showCharge" prop="augustChargeAmount" label="计费" width="80">
                <template slot-scope="scope">
                  <el-input-number placeholder="请输入金额"  v-if="editMode" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.augustChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.augustChargeAmount }}
                    </template> 
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="augustNotChargeAmount" label="不计费" width="80">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'augustNotChargeAmount')"
                    v-model="scope.row.augustNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.augustNotChargeAmount }}
                    </template> 
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '09'">
              <el-table-column v-if="showCharge" prop="septemberChargeAmount" label="计费" width="80">
                <template slot-scope="scope">
                  <el-input-number placeholder="请输入金额" v-if="editMode" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.septemberChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.augustNotChargeAmount }}
                    </template> 
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="septemberNotChargeAmount" label="不计费" width="80">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'septemberNotChargeAmount')"
                    v-model="scope.row.septemberNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.septemberNotChargeAmount }}
                    </template> 
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '10'">
              <el-table-column v-if="showCharge" prop="octoberChargeAmount" label="计费" width="80">
                <template slot-scope="scope">
                  <el-input-number v-if="editMode" placeholder="请输入金额" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.octoberChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.octoberChargeAmount }}
                    </template>
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="octoberNotChargeAmount" label="不计费" width="80">
                <template slot-scope="scope">
                  <el-input-number placeholder="请输入金额" v-if="editMode" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'octoberNotChargeAmount')"
                    v-model="scope.row.octoberNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.octoberNotChargeAmount }}
                    </template>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '11'">
              <el-table-column v-if="showCharge" prop="novemberChargeAmount" label="计费" width="80">
                <template slot-scope="scope">
                  <el-input-number placeholder="请输入金额" v-if="editMode" :precision="2" :controls="false"
                    @change="chargingAmountChange(scope.row)" v-model="scope.row.novemberChargeAmount"
                    style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.novemberChargeAmount }}
                    </template>
                </template>
              </el-table-column>
              <el-table-column v-if="showNotCharge" prop="novemberNotChargeAmount" label="不计费" width="80">
                <template slot-scope="scope">
                  <el-input-number placeholder="请输入金额" v-if="editMode" :precision="2" :controls="false"
                    @change="noChargingAmountChange(scope.row, 'novemberNotChargeAmount')"
                    v-model="scope.row.novemberNotChargeAmount" style="width:100%"></el-input-number>
                    <template v-else>
                      {{ scope.row.novemberNotChargeAmount }}
                    </template>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="columnLabel + '12'">
              <el-table-column v-if="showCharge"  prop="decemberChargeAmount" label="计费" width="80"></el-table-column>
              <el-table-column v-if="showNotCharge" prop="decemberNotChargeAmount" label="不计费"
                width="80"></el-table-column>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick
        @click="proTemSave">暂 存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetDeptApplyQuotaById,
  SaveDeptApplyQuota,
  GetDeptApplyQuotaUses,
  RejectDeptApplyQuota,
  GetLastYearInitQuotas,
  GetDepts
} from "@/api";
import { AnnualOptions, DeptApplyQuotaTypeOptions } from "@/enum";
// import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "DeptApplyQuotaEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    // SelectTable,
    ApproveInfo
  },
  data () {
    return {
      loading: false,
      GetDataAction: GetDeptApplyQuotaById,
      SaveDataAction: SaveDeptApplyQuota,
      reject: RejectDeptApplyQuota,
      form: {},
      AnnualOptions: AnnualOptions,
      DeptApplyQuotaTypeOptions: DeptApplyQuotaTypeOptions,
      rules: {
        warehouseName: [
          { required: true, message: '请选择入库仓库', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择入库日期', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择入库类型', trigger: 'blur' }
        ],
        supplierName: [{ required: true, message: '请选择供应商', trigger: 'blur' }]
      },
      childFormRules: {
        // manufactureDate: [{ required: true, message: "请选择生产日期", trigger: "blur" }],
        // validityDate: [{ required: true, message: "请选择有效期", trigger: "blur" }],
        // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        // productRegistCertId: [{ required: true, message: "请选择产品注册证", trigger: "blur" }],
        // packSpec: [{ required: true, message: "请输入包装规格", trigger: "blur" }],
        price: [
          { required: true, message: "请输入采购价", trigger: "blur" },
        ],
        number: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,

      showCharge: false,
      showNotCharge: true,
      deptList: [],

      columnLabel: "",
      // detailsObj: {},
      oldYearList: []
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    this.getDeptList()
    this.getDeptList1()
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
      let year = this.$route.query.year
      if (year) {
        this.form.year = year * 1 + 1
        this.columnLabel = this.form.year + '-'
        GetDeptApplyQuotaUses({ pageIndex: 1, pageSize: 200, year: year, isReturnDetails: 1 })
          .then(res => {
            if (res.returnData.data && res.returnData.data.length > 0) {
              res.returnData.data.map((e, i) => {
                e.type.split(';').map(t => {
                  if (this.form.typeArr.indexOf(t * 1) == -1) {
                    this.form.typeArr.push(t * 1)
                  }
                })

                let detail = {}
                detail.deptId = e.deptId
                detail.deptName = e.deptName
                detail.lastYearChargeAmount = e.chargeAmounted
                detail.chargeAmount = e.chargeAmounted
                detail.lastYearNotChargeAmount = e.notChargeAmounted
                detail.notChargeAmount = e.notChargeAmounted
                if (e.details) {
                  e.details.forEach(eDetail => {
                    if (eDetail.monthStr.indexOf('-01') != -1) {
                      detail.januaryChargeAmount = eDetail.chargeAmounted
                      detail.januaryNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastJanuaryChargeAmount = eDetail.chargeAmounted
                      detail.lastJanuaryNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-02') != -1) {
                      detail.februaryChargeAmount = eDetail.chargeAmounted
                      detail.februaryNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastFebruaryChargeAmount = eDetail.chargeAmounted
                      detail.lastFebruaryNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-03') != -1) {
                      detail.marchChargeAmount = eDetail.chargeAmounted
                      detail.marchNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastMarchChargeAmount = eDetail.chargeAmounted
                      detail.lastMarchNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-04') != -1) {
                      detail.aprilChargeAmount = eDetail.chargeAmounted
                      detail.aprilNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastAprilChargeAmount = eDetail.chargeAmounted
                      detail.lastAprilNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-05') != -1) {
                      detail.mayChargeAmount = eDetail.chargeAmounted
                      detail.mayNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastMayChargeAmount = eDetail.chargeAmounted
                      detail.lastMayNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-06') != -1) {
                      detail.juneChargeAmount = eDetail.chargeAmounted
                      detail.juneNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastJuneChargeAmount = eDetail.chargeAmounted
                      detail.lastJuneNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-07') != -1) {
                      detail.julyChargeAmount = eDetail.chargeAmounted
                      detail.julyNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastJulyChargeAmount = eDetail.chargeAmounted
                      detail.lastJulyNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-08') != -1) {
                      detail.augustChargeAmount = eDetail.chargeAmounted
                      detail.augustNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastAugustChargeAmount = eDetail.chargeAmounted
                      detail.lastAugustNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-09') != -1) {
                      detail.septemberChargeAmount = eDetail.chargeAmounted
                      detail.septemberNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastSeptemberChargeAmount = eDetail.chargeAmounted
                      detail.lastSeptemberNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-10') != -1) {
                      detail.octoberChargeAmount = eDetail.chargeAmounted
                      detail.octoberNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastOctoberChargeAmount = eDetail.chargeAmounted
                      detail.lastOctoberNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-11') != -1) {
                      detail.novemberChargeAmount = eDetail.chargeAmounted
                      detail.novemberNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastNovemberChargeAmount = eDetail.chargeAmounted
                      detail.lastNovemberNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-12') != -1) {
                      detail.decemberChargeAmount = eDetail.chargeAmounted
                      detail.decemberNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastDecemberChargeAmount = eDetail.chargeAmounted
                      detail.lastDecemberNotChargeAmount = eDetail.notChargeAmounted
                    }
                  })
                }

                this.form.details.push(detail)
              })
              this.form.details.forEach((e, index) => {
                e.$index = index + 1;
              });
              this.form.type = this.form.typeArr.join(';')

              this.showCharge = Boolean(this.form.typeArr.find(e => e === 1))
              this.showNotCharge = Boolean(this.form.typeArr.find(e => e === 2))
            }
            else {
              this.$my_message(`上一年度没有申报明细`, "warning");
              return false
            }
          })
      }
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.form.typeArr = this.form.type.split(';')
        this.form.typeArr = this.form.typeArr.map(e => {
          return e * 1
        })

        this.showCharge = Boolean(this.form.typeArr.find(e => e === 1))
        this.showNotCharge = Boolean(this.form.typeArr.find(e => e === 2))
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }

        if (!this.form.details || this.form.details.length == 0) {
          this.$my_message(`申报明细不能为空`, "warning");
          return false
        }

        for (let i = 0; i < this.form.details.length; i++) {
          if (this.showCharge && (!this.form.details[i].chargeAmount || this.form.details[i].chargeAmount === 0)) {
            this.$my_message(`第${i + 1}行请领限额(计费)不能为0`, "warning");
            return false
          }
          if (this.showNotCharge && (!this.form.details[i].notChargeAmount || this.form.details[i].notChargeAmount === 0)) {
            this.$my_message(`第${i + 1}行请领限额(不计费)不能为0`, "warning");
            return false
          }
          if(this.form.details[i].exceed==true){
            this.$my_message(`第${i + 1}行月额度之和不能超过总限额`, "warning");
            return false 
          }
        }

        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    tableRowClassName({row, rowIndex}) {
        if (row.exceed) {
          return 'exceed';
        }else{
          return ''
        }
    },
    resetForm () {
      this.form = {
        "no": '',
        "year": '',
        "type": '2',
        typeArr: [2],
        "details": [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      if (this.prevRoute.path == '/') {
        this.$router.go(-1)
      }
      else {
        this.routePushWithParams(this.prevRoute.path, this.$route.params);
      }
    },

    // 明细表
    handleAddChildForm () {
      if (!this.form.year) {
        this.$message({
          message: '请选择所属年度后再添加明细',
          type: 'warning'
        });
        this.getProductList('')
        return
      }
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.form.details.push(this.childForm)
      this.$nextTick(() => {
        this.$refs.childTable.doLayout()
      })
      this.getDeptList()
      this.getDeptList1()
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },

    resetDetailFormData () {
      this.childForm = {
        addShow: true,
        $index: this.form.details.length + 1,
        deptId: '',
        deptName: '',
        chargeAmount: 0,
        notChargeAmount: 0,
        lastYearChargeAmount: 0,
        lastYearNotChargeAmount: 0,
        januaryChargeAmount: 0,
        februaryChargeAmount: 0,
        marchChargeAmount: 0,
        aprilChargeAmount: 0,
        mayChargeAmount: 0,
        juneChargeAmount: 0,
        julyChargeAmount: 0,
        augustChargeAmount: 0,
        septemberChargeAmount: 0,
        octoberChargeAmount: 0,
        novemberChargeAmount: 0,
        decemberChargeAmount: 0,
        januaryNotChargeAmount: 0,
        februaryNotChargeAmount: 0,
        marchNotChargeAmount: 0,
        aprilNotChargeAmount: 0,
        mayNotChargeAmount: 0,
        juneNotChargeAmount: 0,
        julyNotChargeAmount: 0,
        augustNotChargeAmount: 0,
        septemberNotChargeAmount: 0,
        octoberNotChargeAmount: 0,
        novemberNotChargeAmount: 0,
        decemberNotChargeAmount: 0
      };
    },

    cell({row, column, rowIndex, columnIndex}) {
      if(row[column.property]<0){
         return 'red'
      }
    },
    deptChange (val, row) {
      let arr = this.form.details.filter(res => res.deptId == val)
      let deptInfo = this.deptList.filter(res => res.id == val)
      if (arr.length == 0) {
        if (this.oldYearList.length == 0) {
          row.deptId = val
          row.isTwoWarehouse = deptInfo[0].isTwoWarehouse
        } else {
          let a = this.oldYearList.filter(res => res.deptId == val)  
          console.log(a);
                  
          row.deptId = val
          row.chargeAmount = a[0].chargeAmount
          row.isTwoWarehouse = a[0].isTwoWarehouse
          row.notChargeAmount = a[0].notChargeAmount
          row.lastYearChargeAmount = a[0].lastYearChargeAmount
          row.lastYearNotChargeAmount = a[0].lastYearNotChargeAmount
          row.januaryChargeAmount = a[0].januaryChargeAmount
          row.februaryChargeAmount = a[0].februaryChargeAmount
          row.marchChargeAmount = a[0].marchChargeAmount
          row.aprilChargeAmount = a[0].aprilChargeAmount
          row.mayChargeAmount = a[0].mayChargeAmount
          row.juneChargeAmount = a[0].juneChargeAmount
          row.julyChargeAmount = a[0].julyChargeAmount
          row.augustChargeAmount = a[0].augustChargeAmount
          row.septemberChargeAmount = a[0].septemberChargeAmount
          row.octoberChargeAmount = a[0].octoberChargeAmount
          row.novemberChargeAmount = a[0].novemberChargeAmount
          row.decemberChargeAmount = a[0].decemberChargeAmount
          row.januaryNotChargeAmount = a[0].januaryNotChargeAmount
          row.februaryNotChargeAmount = a[0].februaryNotChargeAmount
          row.marchNotChargeAmount = a[0].marchNotChargeAmount
          row.aprilNotChargeAmount = a[0].aprilNotChargeAmount
          row.mayNotChargeAmount = a[0].mayNotChargeAmount
          row.juneNotChargeAmount = a[0].juneNotChargeAmount
          row.julyNotChargeAmount = a[0].julyNotChargeAmount
          row.augustNotChargeAmount = a[0].augustNotChargeAmount
          row.septemberNotChargeAmount = a[0].septemberNotChargeAmount
          row.octoberNotChargeAmount = a[0].octoberNotChargeAmount
          row.novemberNotChargeAmount = a[0].novemberNotChargeAmount
          row.decemberNotChargeAmount = a[0].decemberNotChargeAmount
          row.lastFebruaryChargeAmount = a[0].februaryChargeAmount
          row.lastFebruaryNotChargeAmount = a[0].februaryNotChargeAmount
          row.lastJanuaryChargeAmount = a[0].januaryChargeAmount
          row.lastJanuaryNotChargeAmount = a[0].januaryNotChargeAmount
          row.lastMarchChargeAmount = a[0].marchChargeAmount
          row.lastMarchNotChargeAmount = a[0].marchNotChargeAmount
          row.lastAprilChargeAmount = a[0].aprilChargeAmount
          row.lastAprilNotChargeAmount = a[0].aprilNotChargeAmount
          row.lastMayChargeAmount = a[0].mayChargeAmount
          row.lastMayNotChargeAmount = a[0].mayNotChargeAmount
          row.lastJuneChargeAmount = a[0].juneChargeAmount
          row.lastJuneNotChargeAmount = a[0].juneNotChargeAmount
          row.lastJulyChargeAmount = a[0].julyChargeAmount
          row.lastJulyNotChargeAmount = a[0].julyNotChargeAmount
          row.lastSeptemberChargeAmount = a[0].septemberChargeAmount
          row.lastSeptemberNotChargeAmount = a[0].septemberNotChargeAmount
          row.lastOctoberChargeAmount = a[0].octoberChargeAmount
          row.lastOctoberNotChargeAmount = a[0].octoberNotChargeAmount
          row.lastNovemberChargeAmount = a[0].novemberChargeAmount
          row.lastNovemberNotChargeAmount = a[0].novemberNotChargeAmount
          row.lastDecemberChargeAmount = a[0].decemberChargeAmount
          row.lastDecemberNotChargeAmount = a[0].decemberNotChargeAmount
          row.lastAugustChargeAmount = a[0].augustChargeAmount
          row.lastAugustNotChargeAmount = a[0].augustNotChargeAmount
          row.isTwoWarehouse = deptInfo[0].isTwoWarehouse
          this.$forceUpdate();
        }

      } else {
        this.$message({
          message: '不能选择重复的科室',
          type: 'warning'
        });
        row.deptName = ''
      }
    },
    typeChange (val) {
      if (!val || val.length == 0) {
        this.form.typeArr = [2]
        val = [2]
      }

      this.showCharge = Boolean(val.find(e => e === 1))
      this.showNotCharge = Boolean(val.find(e => e === 2))

      this.form.type = val.join(';')
      // console.log(this.form.type)
      this.$nextTick(() => {
        this.$refs.childTable.doLayout()
      })
    },
    yearChange (val) {
      this.loading = true
      if (val) {
        this.columnLabel = val + '-'
      }
      else {
        this.columnLabel = ""
      }

      this.form.details = []
      var query = {
        pageIndex: 1,
        pageSize: 200,
        isHaveWarehouse: 1
      }
      GetDepts(query)
        .then((response) => {
          if (response.returnData.data) {
            response.returnData.data.map((e, i) => {
              this.form.details.push({
                $index: i + 1,
                isTwoWarehouse: e.isTwoWarehouse,
                deptId: e.id,
                deptName: e.name,
                chargeAmount: 0,
                notChargeAmount: 0,
                lastYearChargeAmount: 0,
                lastYearNotChargeAmount: 0,
                januaryChargeAmount: 0,
                februaryChargeAmount: 0,
                marchChargeAmount: 0,
                aprilChargeAmount: 0,
                mayChargeAmount: 0,
                juneChargeAmount: 0,
                julyChargeAmount: 0,
                augustChargeAmount: 0,
                septemberChargeAmount: 0,
                octoberChargeAmount: 0,
                novemberChargeAmount: 0,
                decemberChargeAmount: 0,
                januaryNotChargeAmount: 0,
                februaryNotChargeAmount: 0,
                marchNotChargeAmount: 0,
                aprilNotChargeAmount: 0,
                mayNotChargeAmount: 0,
                juneNotChargeAmount: 0,
                julyNotChargeAmount: 0,
                augustNotChargeAmount: 0,
                septemberNotChargeAmount: 0,
                octoberNotChargeAmount: 0,
                novemberNotChargeAmount: 0,
                decemberNotChargeAmount: 0
              })
            })
          }

          return  GetLastYearInitQuotas({ year: val - 1 }).then(l => {
        this.getDeptList1()
        this.oldYearList = l.returnData
        let arr1 = []
        this.form.details.forEach((eDetail, index) => {
          let arr = l.returnData.filter(i => i.deptId == eDetail.deptId)
          
          arr[0].deptName = arr[0].deptId
          arr[0].isTwoWarehouse = eDetail.isTwoWarehouse
          arr[0].lastYearChargeAmount = this.getTotalNum(arr[0]).num
          arr[0].lastYearNotChargeAmount = this.getTotalNum(arr[0]).NoNum
          arr[0].notChargeAmount = this.getTotalNum(arr[0]).NoNum
          arr[0].chargeAmount = this.getTotalNum(arr[0]).num
          arr[0].lastFebruaryNotChargeAmount = arr[0].februaryNotChargeAmount
          arr[0].lastFebruaryChargeAmount = arr[0].februaryChargeAmount
          arr[0].lastJanuaryChargeAmount = arr[0].januaryChargeAmount
          arr[0].lastJanuaryNotChargeAmount = arr[0].januaryNotChargeAmount
          arr[0].lastMarchChargeAmount = arr[0].marchChargeAmount
          arr[0].lastMarchNotChargeAmount = arr[0].marchNotChargeAmount
          arr[0].lastAprilChargeAmount = arr[0].aprilChargeAmount
          arr[0].lastAprilNotChargeAmount = arr[0].aprilNotChargeAmount
          arr[0].lastMayChargeAmount = arr[0].mayChargeAmount
          arr[0].lastMayNotChargeAmount = arr[0].mayNotChargeAmount
          arr[0].lastAugustChargeAmount = arr[0].augustNotChargeAmount
          arr[0].lastAugustNotChargeAmount = arr[0].augustChargeAmount
          arr[0].lastJuneChargeAmount = arr[0].juneChargeAmount
          arr[0].lastJuneNotChargeAmount = arr[0].juneNotChargeAmount
          arr[0].lastJulyChargeAmount = arr[0].julyChargeAmoun
          arr[0].lastJulyNotChargeAmount = arr[0].julyNotChargeAmount
          arr[0].lastSeptemberChargeAmount = arr[0].septemberChargeAmount
          arr[0].lastSeptemberNotChargeAmount = arr[0].septemberNotChargeAmount
          arr[0].lastOctoberChargeAmount = arr[0].octoberChargeAmount
          arr[0].lastOctoberNotChargeAmount = arr[0].octoberNotChargeAmount
          arr[0].lastNovemberChargeAmount = arr[0].novemberChargeAmount
          arr[0].lastNovemberNotChargeAmount = arr[0].novemberNotChargeAmount
          arr[0].lastDecemberChargeAmount = arr[0].decemberChargeAmount
          arr[0].lastDecemberNotChargeAmount = arr[0].decemberNotChargeAmount
          arr1.push(arr[0])
        })
        this.$nextTick(() => {
          this.form.details = arr1
          this.loading = false
        })

        GetDeptApplyQuotaUses({ pageIndex: 1, pageSize: 200, year: val - 1, isReturnDetails: 1 })
        })
        .then(res => {
          if (res.returnData.data.length != 0) {
            this.getDeptList()

            res.returnData.data.map((e, i) => {
              let detail = this.form.details.find(x => x.deptId == e.deptId)
              if (detail) {
                detail.lastYearChargeAmount = e.chargeAmounted
                detail.chargeAmount = e.chargeAmounted
                detail.lastYearNotChargeAmount = e.notChargeAmounted
                detail.notChargeAmount = e.notChargeAmounted
                if (e.details) {
                  e.details.forEach(eDetail => {
                    if (eDetail.monthStr.indexOf('-01') != -1) {
                      detail.januaryChargeAmount = eDetail.chargeAmounted
                      detail.januaryNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastJanuaryChargeAmount = eDetail.chargeAmounted
                      detail.lastJanuaryNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-02') != -1) {
                      detail.februaryChargeAmount = eDetail.chargeAmounted
                      detail.februaryNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastFebruaryChargeAmount = eDetail.chargeAmounted
                      detail.lastFebruaryNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-03') != -1) {
                      detail.marchChargeAmount = eDetail.chargeAmounted
                      detail.marchNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastMarchChargeAmount = eDetail.chargeAmounted
                      detail.lastMarchNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-04') != -1) {
                      detail.aprilChargeAmount = eDetail.chargeAmounted
                      detail.aprilNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastAprilChargeAmount = eDetail.chargeAmounted
                      detail.lastAprilNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-05') != -1) {
                      detail.mayChargeAmount = eDetail.chargeAmounted
                      detail.mayNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastMayChargeAmount = eDetail.chargeAmounted
                      detail.lastMayNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-06') != -1) {
                      detail.juneChargeAmount = eDetail.chargeAmounted
                      detail.juneNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastJuneChargeAmount = eDetail.chargeAmounted
                      detail.lastJuneNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-07') != -1) {
                      detail.julyChargeAmount = eDetail.chargeAmounted
                      detail.julyNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastJulyChargeAmount = eDetail.chargeAmounted
                      detail.lastJulyNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-08') != -1) {
                      detail.augustChargeAmount = eDetail.chargeAmounted
                      detail.augustNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastAugustChargeAmount = eDetail.chargeAmounted
                      detail.lastAugustNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-09') != -1) {
                      detail.septemberChargeAmount = eDetail.chargeAmounted
                      detail.septemberNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastSeptemberChargeAmount = eDetail.chargeAmounted
                      detail.lastSeptemberNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-10') != -1) {
                      detail.octoberChargeAmount = eDetail.chargeAmounted
                      detail.octoberNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastOctoberChargeAmount = eDetail.chargeAmounted
                      detail.lastOctoberNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-11') != -1) {
                      detail.novemberChargeAmount = eDetail.chargeAmounted
                      detail.novemberNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastNovemberChargeAmount = eDetail.chargeAmounted
                      detail.lastNovemberNotChargeAmount = eDetail.notChargeAmounted
                    }
                    if (eDetail.monthStr.indexOf('-12') != -1) {
                      detail.decemberChargeAmount = eDetail.chargeAmounted
                      detail.decemberNotChargeAmount = eDetail.notChargeAmounted
                      detail.lastDecemberChargeAmount = eDetail.chargeAmounted
                      detail.lastDecemberNotChargeAmount = eDetail.notChargeAmounted
                    }
                  })
                }

                this.form.details = this.form.details.map(e => {
                  e.lastYearChargeAmount = this.getTotalNum(e).num
                  e.lastYearNotChargeAmount = this.getTotalNum(e).NoNum
                  e.notChargeAmount = this.getTotalNum(e).NoNum
                  e.chargeAmount = this.getTotalNum(e).num
                  return e
                })
                
                  let arr = []
                  let arr1 =  this.oldYearList
                  this.form.details.forEach(j=>{
                    let matchingItem =  arr1.find(item1 => item1.deptId === j.deptId);
                    if (matchingItem) {
                      // 如果 deptId 相等，保留 arr 中的元素
                      arr.push(j);
                      // 删除已经匹配的 arr1 中的元素，避免重复添加
                      arr1 = arr1.filter(item1 => item1.deptId !== i.deptId);
                    }else{
                      arr.push(j)
                    }
                  })
                this.oldYearList = arr.concat(arr1)
                this.loading = false
              }
            })
            this.$forceUpdate()
          } 

        })

      })
    },


    chargeAmountChange (row) {
      let months = [
        { key: 'januaryChargeAmount', val: row.lastJanuaryChargeAmount },
        { key: 'februaryChargeAmount', val: row.lastFebruaryChargeAmount },
        { key: 'marchChargeAmount', val: row.lastMarchChargeAmount },
        { key: 'aprilChargeAmount', val: row.lastAprilChargeAmount },
        { key: 'mayChargeAmount', val: row.lastMayChargeAmount },
        { key: 'juneChargeAmount', val: row.lastJuneChargeAmount },
        { key: 'julyChargeAmount', val: row.lastJulyChargeAmount },
        { key: 'augustChargeAmount', val: row.lastAugustChargeAmount },
        { key: 'septemberChargeAmount', val: row.lastSeptemberChargeAmount },
        { key: 'octoberChargeAmount', val: row.lastOctoberChargeAmount },
        { key: 'novemberChargeAmount', val: row.lastNovemberChargeAmount },
        { key: 'decemberChargeAmount', val: row.lastDecemberChargeAmount }
      ]
      let totalAmount = row.chargeAmount; // 本年总金额
      let lastTotalAmount = row.lastYearChargeAmount; // 上年总金额
      console.log(row,months);
      
      // 判断上一年是否所有月份为0
      const allZero = months.every(month => month.val === 0);

      if (allZero) {
        // 处理所有月份为0的情况
        this.handleAllZeroMonths(totalAmount, months, row,'');
      } else {
        // 判断上一年是否所有月份都有值
        const nonZeroMonths = months.filter(month => month.val > 0);
        if (nonZeroMonths.length === 12) {
          // 所有月份都有值
          this.handleAllNonZeroMonths(totalAmount, lastTotalAmount, months, row,'');
        } else {
          // 部分月份为0，部分有值
          this.handlePartialZeroMonths(totalAmount, lastTotalAmount, months, row,'');
        }
      }
      // 确保12月金额为非负数
      row.decemberChargeAmount = row.decemberChargeAmount < 0 ? 0 : row.decemberChargeAmount;
   
    },

    notChargeAmountChange (row) {
      
      let months = [
        { key: 'januaryNotChargeAmount', val: row.lastJanuaryNotChargeAmount },
        { key: 'februaryNotChargeAmount', val: row.lastFebruaryNotChargeAmount },
        { key: 'marchNotChargeAmount', val: row.lastMarchNotChargeAmount },
        { key: 'aprilNotChargeAmount', val: row.lastAprilNotChargeAmount },
        { key: 'mayNotChargeAmount', val: row.lastMayNotChargeAmount },
        { key: 'juneNotChargeAmount', val: row.lastJuneNotChargeAmount },
        { key: 'julyNotChargeAmount', val: row.lastJulyNotChargeAmount },
        { key: 'augustNotChargeAmount', val: row.lastAugustNotChargeAmount },
        { key: 'septemberNotChargeAmount', val: row.lastSeptemberNotChargeAmount },
        { key: 'octoberNotChargeAmount', val: row.lastOctoberNotChargeAmount },
        { key: 'novemberNotChargeAmount', val: row.lastNovemberNotChargeAmount },
        { key: 'decemberNotChargeAmount', val: row.lastDecemberNotChargeAmount }
      ]
      let totalAmount = row.notChargeAmount; // 本年总金额
      let lastTotalAmount = row.lastYearNotChargeAmount; // 上年总金额
      
      // 判断上一年是否所有月份为0
      const allZero = months.every(month => month.val === 0);

      if (allZero) {
        // 处理所有月份为0的情况
        this.handleAllZeroMonths(totalAmount, months, row ,'not');
      } else {
        // 判断上一年是否所有月份都有值
        const nonZeroMonths = months.filter(month => month.val > 0);
        if (nonZeroMonths.length === 12) {
          // 所有月份都有值
          this.handleAllNonZeroMonths(totalAmount, lastTotalAmount, months, row,'not');
        } else {
          // 部分月份为0，部分有值
          this.handlePartialZeroMonths(totalAmount, lastTotalAmount, months, row,'not');
        }
      }
      // 确保12月金额为非负数
      row.decemberNotChargeAmount = row.decemberNotChargeAmount < 0 ? 0 : row.decemberNotChargeAmount;
    },

    getTotalNum (obj) {
      let NoNum = obj.januaryNotChargeAmount + obj.februaryNotChargeAmount + obj.marchNotChargeAmount + obj.aprilNotChargeAmount + obj.mayNotChargeAmount + obj.juneNotChargeAmount + obj.julyNotChargeAmount + obj.augustNotChargeAmount + obj.septemberNotChargeAmount + obj.octoberNotChargeAmount + obj.novemberNotChargeAmount + obj.decemberNotChargeAmount

      let num = obj.januaryChargeAmount + obj.februaryChargeAmount + obj.marchChargeAmount + obj.aprilChargeAmount + obj.mayChargeAmount + obj.juneChargeAmount + obj.julyChargeAmount + obj.augustChargeAmount + obj.septemberChargeAmount + obj.octoberChargeAmount + obj.novemberChargeAmount + obj.decemberChargeAmount
      NoNum = NoNum.toFixed(2)
      num = num.toFixed(2)
      return { NoNum, num }
    },
    // 计算某个月的金额，按1/12比例
    calculateEqualDistribution(totalAmount) {
      return (totalAmount / 12).toFixed(2) * 1;
    },
    // 计算某个月的金额，按实际比例分配
    calculateProportionalDistribution(totalAmount, monthValue, lastTotalAmount) {
      return (totalAmount * (monthValue / lastTotalAmount)).toFixed(2) * 1;
    },
    // 计算12月金额，年总额减去前11个月的和
    calculateDecemberAmount(totalAmount, months, row) {
      let totalUsed = months.slice(0, 11).reduce((sum, month) => sum + row[month.key], 0);
      return (totalAmount - totalUsed).toFixed(2) * 1;
    },
    // 处理所有月份为0的情况
    handleAllZeroMonths(totalAmount, months, row,not) {
      months.forEach((month, index) => {
        if (index < 11) {
          row[month.key] = this.calculateEqualDistribution(totalAmount);
        }
      });
      if(not){
        row.decemberNotChargeAmount = this.calculateDecemberAmount(totalAmount, months, row);
      }else{
        row.decemberChargeAmount = this.calculateDecemberAmount(totalAmount, months, row);
      }
    },
    // 处理所有月份都有值的情况
    handleAllNonZeroMonths(totalAmount, lastTotalAmount, months, row,not) {
      let totalUsed = 0;
      months.slice(0, 11).forEach((month) => {
        row[month.key] = this.calculateProportionalDistribution(totalAmount, month.val, lastTotalAmount);
        totalUsed += row[month.key];
      });
      if(not){
        row.decemberNotChargeAmount = (totalAmount - totalUsed).toFixed(2) * 1; 
      }else{
        row.decemberChargeAmount = (totalAmount - totalUsed).toFixed(2) * 1; 
      }
      
    },
    // 处理部分月份为0的情况
    handlePartialZeroMonths(totalAmount, lastTotalAmount, months, row) {
      let totalUsed = 0;
      let remainingAmount = totalAmount;
      let  MonthlyTotalAmount  =  totalAmount
      // 先处理为0的月份，按1/12比例分配
      let zeroMonths = months.filter(month => month.val === 0);
      zeroMonths.forEach((month) => {
        row[month.key] = this.calculateEqualDistribution(totalAmount);
        totalUsed += row[month.key];
        MonthlyTotalAmount -= row[month.key]
      });

      // 对于非零月份，按比例分配
      let nonZeroMonths = months.filter(month => month.val > 0);
      nonZeroMonths.slice(0, nonZeroMonths.length - 1).forEach((month) => {
        let proportion = month.val / lastTotalAmount;
        row[month.key] = (MonthlyTotalAmount * proportion).toFixed(2) * 1;
        totalUsed += row[month.key];
        MonthlyTotalAmount -= row[month.key];
      });

      
      // 最后一个非零月份，按剩余的金额计算
      let lastNonZeroMonth = nonZeroMonths[nonZeroMonths.length - 1];
      
      row[lastNonZeroMonth.key] = (totalAmount - totalUsed).toFixed(2) * 1;
    },
  

    noChargingAmountChange (row, name) {
      let num = row.novemberNotChargeAmount + row.februaryNotChargeAmount + row.marchNotChargeAmount + row.aprilNotChargeAmount + row.mayNotChargeAmount + row.juneNotChargeAmount + row.augustNotChargeAmount + row.augustNotChargeAmount + row.septemberNotChargeAmount + row.octoberNotChargeAmount + row.novemberNotChargeAmount
      
      if (row.notChargeAmount - num < 0) {
        this.$set(row,'exceed',true)
        this.$message({
          message: '月额度之和不能超过总限额',
          type: 'warning'
        });
      } else {
        this.$set(row,'exceed',false)
        row.decemberNotChargeAmount = (row.notChargeAmount - num).toFixed(2)
      }
      this.$forceUpdate()
    },
    chargingAmountChange (row) {

      let num = row.novemberChargeAmount + row.februaryChargeAmount + row.marchChargeAmount + row.aprilChargeAmount + row.mayChargeAmount + row.juneChargeAmount + row.augustChargeAmount + row.augustChargeAmount + row.septemberChargeAmount + row.octoberChargeAmount + row.novemberChargeAmount
    
      if (row.chargeAmount - num < 0) {
        this.$set(row,'exceed',true)
        this.$message({
          message: '月额度之和不能超过总限额',
          type: 'warning'
        });

      } else {
        this.$set(row,'exceed',false)
        row.decemberChargeAmount = (row.ChargeAmount - num).toFixed(2)
      }
      this.$forceUpdate()
    },
    getDeptList (val) {
      var query = {
        pageIndex: 1,
        pageSize: 200,
        isHaveWarehouse: 1,
        keyWord: val
      }
      GetDepts(query).then((response) => {
        this.deptList = response.returnData.data;
      });
    },
    getDeptList1 (val) {
      var query = {
        pageIndex: 1,
        pageSize: 200,
        keyWord: val
      }
      GetDepts(query).then((response) => {
        this.deptList = response.returnData.data;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__header-wrapper {
  height: 100% !important;
}

/deep/ .el-table__fixed-header-wrapper {
  height: 100% !important;
}

/deep/ .el-table__fixed-body-wrapper {
  top: 52px !important;
}
/deep/.red{
  background-color: rgba(255, 0, 0, 0.518) !important;
}
/deep/ .exceed {
  background:rgba(255, 0, 0, 0.518) !important;
}
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}

::v-deep .el-table__fixed {
  // 左固定列
  height: auto !important;
  bottom: 12px; // 改为自动高度后，设置与父容器的底部距离，高度会动态改变，值可以设置比滚动条的高度稍微大一些,这个根据实际情况改
}

// ::v-deep .el-table__fixed-right {
//   // 右固定列
//   height: auto !important;
//   bottom: 12px;
// }</style>
